export const prodDomain = '.leroymerlin.ru';
